import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { InputMaskModule } from '@ngneat/input-mask';

import { TaxOnboardingComponent } from './tax-onboarding.component';

// Declared in its own module because two feature modules pull it in: the root
// AppModule, for the blocking step in the app shell, and SettingsPageModule for
// the 1099 tab.
@NgModule({
  declarations: [TaxOnboardingComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    InputMaskModule,
  ],
  exports: [TaxOnboardingComponent],
})
export class TaxOnboardingModule {}
